import Icon from "components/global/Icon";
import Text from "components/typography/Text";
import pseudoFormat from "utils/pseudoFormat";

// ** SVG Static Imports
import { ReactComponent as RegularHeart } from "resources/icons/regular/heart.svg";

export default ({ likes, withZero, color, ...rest }) => {
	return (
		<Text textNowrap {...rest}>
			<Text block mx={1}>
				<Icon type="far" color={color} svgIconComponent={RegularHeart}>
					heart
				</Icon>
			</Text>
			{likes > 0 || withZero ? (
				<Text color={color} block>
					{pseudoFormat(likes)}
				</Text>
			) : null}
		</Text>
	);
};
